import script from "./SegurosSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SegurosSection.vue?vue&type=script&setup=true&lang=js"

import "./SegurosSection.vue?vue&type=style&index=0&id=70fbc9c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70fbc9c8"]])

export default __exports__